import { createContext, useContext, useState, useCallback, useMemo, type ReactNode } from 'react';

interface ReportarProblemaContextType {
  readonly isOpen: boolean;
  readonly sentryEventId: string | undefined;
  readonly abrir: (sentryEventId?: string) => void;
  readonly cerrar: () => void;
}

const ReportarProblemaContext = createContext<ReportarProblemaContextType | undefined>(undefined);

export function ReportarProblemaProvider({ children }: Readonly<{ children: ReactNode }>) {
  const [isOpen, setIsOpen] = useState(false);
  const [sentryEventId, setSentryEventId] = useState<string | undefined>(undefined);

  const abrir = useCallback((eventId?: string) => {
    setSentryEventId(eventId);
    setIsOpen(true);
  }, []);

  const cerrar = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({ isOpen, sentryEventId, abrir, cerrar }),
    [isOpen, sentryEventId, abrir, cerrar]
  );

  return (
    <ReportarProblemaContext.Provider value={value}>
      {children}
    </ReportarProblemaContext.Provider>
  );
}

export function useReportarProblema() {
  const context = useContext(ReportarProblemaContext);
  if (context === undefined) {
    throw new Error('useReportarProblema must be used within a ReportarProblemaProvider');
  }
  return context;
}
